module.exports = __webpack_public_path__ + "static/img/8.5d079c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting596/images/8.png
// module id = +cAU
// module chunks = 4